import React from 'react'
import StudentDashboard from '../../components/student/dashboard'
export default function Dashboard() {
  return (
    <div>
        <StudentDashboard/>
    </div>
  )
}
